import * as Yup from "yup"

const MIN_TOTAL_SLOTS = 0
const MAX_TOTAL_SLOTS = 10
const NUMBER_REGEX = /^[0-9]*$/

const FIELDS_NAME = {
   START_DATE: "startDate",
   END_DATE: "endDate",
   TOTAL_SLOTS: "totalSlots",
   PREMIUM_SLOTS: "premiumSlots",
   REGULAR_SLOTS: "regularSlots",
}

const initialValues = {
   [FIELDS_NAME.START_DATE]: "",
   [FIELDS_NAME.END_DATE]: "",
   [FIELDS_NAME.TOTAL_SLOTS]: 0,
   [FIELDS_NAME.PREMIUM_SLOTS]: 0,
   [FIELDS_NAME.REGULAR_SLOTS]: 0,
}

const validationSchema = Yup.object({
   startDate: Yup.date().required("Required"),
   endDate: Yup.date()
      .min(Yup.ref("startDate"), "End ≥ Start")
      .required("Required"),
   totalSlots: Yup.number()
      .min(MIN_TOTAL_SLOTS, "Total Slots can not be lower than 0")
      .max(MAX_TOTAL_SLOTS, "Total Slots can not be greater than 10")
      .required("Total Slots can not be lower than 0"),
   premiumSlots: Yup.number()
      .min(MIN_TOTAL_SLOTS, "Premium Slots can not be lower than 0")
      .max(MAX_TOTAL_SLOTS, "Premium Slots can not be greater than 10")
      .required("Premium Slots can not be lower than 0"),
   regularSlots: Yup.number()
      .min(MIN_TOTAL_SLOTS, "Regular Slots can not be lower than 0")
      .max(MAX_TOTAL_SLOTS, "Regular Slots can not be greater than 10")
      .required("Regular Slots can not be lower than 0"),
})

export {
   initialValues,
   FIELDS_NAME,
   validationSchema,
   MIN_TOTAL_SLOTS,
   MAX_TOTAL_SLOTS,
   NUMBER_REGEX,
}
